<template>
    <SOFilterBase
        v-if="showFilter"
        @back="back()"
        @do-filter="doFilter()"
        @reset-filter="resetFilter()"
        >
        <template v-slot:filters>
            <div>
                <SOFilterSortingV2
                    id="filter-sorting"
                    :sorting="filterOptions.sortItems"
                />
                <SOFilterPeriode
                    id="tanggal-komplain"
                    title="Tanggal Komplain"
                    ref="filterTanggalKomplain"
                />
                <SOFilterCheckbox
                    id="status-komplain"
                    title="Status Komplain"
                    :items="filterOptions.statusItems"
                    filter-name="statusKomplain"
                />
                <SOFilterOutlet :id="'filter-outlet'" title="Outlet" />
            </div>
        </template>
    </SOFilterBase>
</template>
<script>
import { mapGetters } from "vuex";
import filterOptions from "../static/filterOptions"
import SOFilterBase from "@/so-components/global/filter/base/SOFilterBase";
import SOFilterSortingV2 from "@/so-components/global/filter/type/SOFilterSortingV2";
import SOFilterPeriode from "@/so-components/global/filter/type/SOFilterPeriode";
import SOFilterCheckbox from "@/so-components/global/filter/type/SOFilterCheckbox";
import SOFilterOutlet from "@/so-components/global/filter/type/SOFilterOutlet";

export default {
    name: 'FilterKomplainQris',
    components: {
        SOFilterBase,
        SOFilterSortingV2,
        SOFilterPeriode,
        SOFilterCheckbox,
        SOFilterOutlet
    },
    props: ['value'],
    data() {
        return {
            filterOptions: filterOptions,
        }
    },
    computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem",
            filter: "getFilter"
		}),
        showFilter() {
            return this.value;
        },
    },
    methods: {
        back() {
            this.$emit('input', false)
        },
        doFilter() {
            this.$emit('do-filter')
            this.$emit('input', false)
        },
        resetFilter() {
            this.$store.commit("filterGlobalModule/resetFilterItem");
            this.$store.commit("filterGlobalModule/resetFilter");
            this.$store.commit("filterGlobalModule/setFilter", {"sortBy":"1","orderBy":"ASC"})
        }
    },
}
</script>